import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import { useIsAuthenticated } from '@azure/msal-react';
import colors from '../../../../scss/colors';

export default function BackButton({ label = 'Back to job listings' }) {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  const handleBack = () => {
    if (isAuthenticated) {
      navigate('/dashboard/jobs');
    } else {
      navigate('/jobs');
    }
  };

  return (
    <Button
      onClick={handleBack}
      startIcon={<ArrowBackIcon />}
      sx={{
        textTransform: 'none',
        fontWeight: 500,
        fontFamily: 'Gotham',
        color: colors.LIGHT_BLUE
      }}
      variant="text"
    >
      {label}
    </Button>
  );
}
